<template>
    <v-container fluid>
        <v-card width="100%">
            <v-card-title class="justify-center pt-0 pb-2"><h2>Chats</h2></v-card-title>
            <v-divider></v-divider>
            <v-card-actions v-if="conversation_id===''">
                <v-btn color="primary" small @click="createConversation(false, false)">Start a (general) converstion</v-btn>
                <v-btn color="primary" small @click="createConversation(false, true)">Start an Accommodation Converstion</v-btn>
                <v-btn color="primary" small @click="createConversation(true, false)">Start a Booking Converstion</v-btn>
            </v-card-actions>
        </v-card>
        
        <v-row v-if="conversation_id!==''">
            <v-col cols="12" v-if="loading"><cardWait/></v-col>
            <v-col cols="4">
                <cardVirtualAssistantUpdate ref="cardVirtualAssistantUpdate" :assistant_id="assistant.id" v-if="!loading"/>
            </v-col>
            <v-col cols="8">
                <cardVirtualConversationTest ref="cardVirtualConversationTest" :conversation="conversation" :files="files" :hasBooking="conversation.metadata.huov_code!==''" :hasAcco="conversation.metadata.huis_code!==''" @updateData="getTestConversation" v-if="!loading"/>
            </v-col>
        </v-row>
        <cardVirtualConversationEdit ref="cardVirtualConversationEdit" @updateData="startConversation"/>
        
    </v-container>
</template>

<script>
    import cardVirtualAssistantUpdate from "@/components/syst/openai/cardVirtualAssistantUpdate.vue";
    import cardVirtualConversationEdit from "@/components/syst/openai/cardVirtualConversationEdit.vue";
    import cardVirtualConversationTest from "@/components/syst/openai/cardVirtualConversationTest.vue";
    import cardWait from "@/components/syst/openai/cardWait.vue";

    export default {
        components: {
            cardVirtualAssistantUpdate,
            cardVirtualConversationEdit,
            cardVirtualConversationTest,
            cardWait,
        },
        props: {
            conversation_id: {
                type: String,
                required: false,
                default: "",
            }
        },
        data() {
            return {
                loading: false,

                assistant: {},

                assistants: [],

                files: [],

                conversation: {
                    messages: [],
                    metadata: {
                        huov_code: "",
                    },
                }
            }
        },
        mounted() {
            this.getAssistants();
            this.getTestConversation("");
        },
        methods: {              
            getAssistants() {
                this.$axios.post("ares/json/ares/syst/openai/getAssistants.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAssistants",
                    },
                    getAssistants: {
                        refresh: false,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.assistants = res.data.getAssistants.assistants;
                    }
                });
            },
            getTestConversation(message_id) {
                if (this.conversation_id==="") {
                    this.assistant = {};
                    this.conversation = {
                        messages: [],
                    }
                } else {
                    this.loading = true;
                    this.$axios.post("ares/json/ares/syst/openai/getConversationDetails.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getConversationDetails",
                        },
                        getConversationDetails: {
                            thread_id: this.conversation_id,
                            message_id: message_id,
                        },
                    }).then((res) => {
                        if (res.data.error) {
                            // console.log(res.data.error);
                            this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: res.data.error.message,
                                color: "error",
                            });
                        } else {
                            this.assistant = res.data.getConversationDetails.assistant;
                            this.conversation = res.data.getConversationDetails.conversation;
                            this.files = res.data.getConversationDetails.files;
                            this.loading = false;
                        }
                    });
                }
            },
            startConversation(conversation_id) {
                let route = this.$router.resolve({ path: "/syst/openai/mnOpenai/" + conversation_id}); 
                window.open(route.href, "_self");                
            },
            createConversation(bookingConversation, accoConversation) {
                let newConversation = {
                    id: "",
                    assistant_id: "",
                    file_search_only: true,
                }
                this.$refs.cardVirtualConversationEdit.openDialog(newConversation, this.assistants, bookingConversation, accoConversation);
            }
        }
    }
</script>
